import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";
import HistoryIcon from "@material-ui/icons/History";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";
import ThermalSalesReport from "./ThermalSalesReport";
import ThermalSalesReportIMIN from "./ThermalSalesReportIMIN";
import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  Tooltip,
  Checkbox,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { AppContext } from "../../Context/AppContext";
import { useLocation } from "react-router-dom";
import usePermissions from "../../utils/permissions";
import * as api from "../../api/index";

import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DSRDialog from "./DSRDialog";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteInvoice,
  getInvoicesByUser,
  getInvoices,
  getMinimalInvoices,
  softdeleteInvoice,
  cancelInvoice,
} from "../../actions/invoiceActions";
import { getUsers } from "../../actions/auth";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "8px",
  textAlign: "center",
};
const headerStyle = { borderBottom: "none", textAlign: "center" };
const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const Invoices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const { profiles } = useSelector((state) => state.profiles);
  const { invoices, deletedInvoices } = useSelector((state) => state.invoices);
  const {
    openDSR,
    setOpenDSR,
    dateDSR,
    setDateDSR,
    startDateDSR,
    setStartDateDSR,
    endDateDSR,
    setEndDateDSR,
    showPreviewDSR,
    setShowPreviewDSR,
  } = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 25,
    hasNextPage: false,
    hasPrevPage: false
  });
  const [dateRangeTotals, setDateRangeTotals] = useState({
    totalAmount: 0,
    startDate: null,
    endDate: null
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { users } = useSelector((state) => state.auth);
  const clients = useSelector((state) => state.clients.clients);
  const [loading, setLoading] = useState(false);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const [printIMINReport, setPrintIMINReport] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [salesperson, setSalesperson] = useState(null);
  const [party, setParty] = useState(null);
  const [paymentMode, setPaymentMode] = useState("");
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("");
  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    isAdmin,
  } = usePermissions();

  const [canDownloadReports, setcanDownloadReports] = useState(false);
  const [isAdminn, setIsAdminn] = useState(false);
  const [loadingg, setLoadingg] = useState(true);

  const [permissions, setPermissions] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile")) || {};
        if (!profile.token) throw new Error("No token found");
        setIsAdminn(profile?.result?.userType?.includes("admin") || false);

        const { data } = await api.getUserPermissions();
        setcanDownloadReports(data.canDownloadPdfReports || false);
        setLoadingg(false);
      } catch (error) {
        console.error("Error fetching permissions:", error.message);
        setcanDownloadReports(false);
        setLoadingg(false);
      }
    };
    fetchPermissions();
  }, []);

  useEffect(() => {
    dispatch(getMinimalInvoices(1, 25)); // Explicitly set initial page and limit
    // eslint-disable-next-line
  }, [location, dispatch]);

  // Handle date range changes
  useEffect(() => {
    if (startDate && endDate) {
      const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
      const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
      setPage(0); // Reset to first page when date range changes
      dispatch(getMinimalInvoices(1, rowsPerPage, formattedStartDate, formattedEndDate));
    } else if (!startDate && !endDate) {
      // If both dates are cleared, fetch all data
      setPage(0);
      dispatch(getMinimalInvoices(1, rowsPerPage));
    }
    // eslint-disable-next-line
  }, [startDate, endDate, rowsPerPage]);
  useEffect(() => {
    dispatch(getProfile(user?.userProfile?._id));
  }, [location, dispatch]);
  useEffect(() => {
    // Handle paginated response structure
    if (invoices && Array.isArray(invoices)) {
      // Legacy format - direct array
      if (user?.result?.userType === "user") {
        const rows = invoices.filter(
          (inv) => inv.creator[0] === user?.result?._id
        );
        setRows(rows);
      } else {
        setRows(invoices);
      }
    } else if (invoices && invoices.data && invoices.pagination) {
      // New paginated format
      if (user?.result?.userType === "user") {
        const rows = invoices.data.filter(
          (inv) => inv.creator[0] === user?.result?._id
        );
        setRows(rows);
      } else {
        setRows(invoices.data);
      }
      setPagination(invoices.pagination);
      
      // Handle date range totals if available
      if (invoices.dateRange) {
        setDateRangeTotals({
          totalAmount: invoices.dateRange.totalAmount || 0,
          startDate: invoices.dateRange.startDate,
          endDate: invoices.dateRange.endDate
        });
      }
    }

    // eslint-disable-next-line
  }, [invoices]);

  // Sync page state with server pagination (convert 1-based to 0-based)
  useEffect(() => {
    if (pagination.currentPage !== undefined) {
      setPage(pagination.currentPage - 1);
    }
    if (pagination.limit !== undefined) {
      setRowsPerPage(pagination.limit);
    }
  }, [pagination]);

  useEffect(() => {
    dispatch(getUsers());
  }, [location]);
  useEffect(() => {
    dispatch(
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);


  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const { data } = await api.getUserPermissions();
        setPermissions(data); // 👈 EXACT response you shared
      } catch (error) {
        console.error(error);
      } finally {
        setPermissionLoading(false);
      }
    };
  
    fetchPermissions();
  }, []);
  

  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleDateChange = (newDate) => {
    setDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleStartDateChange = (newDate) => {
    setStartDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleEndDateChange = (newDate) => {
    setEndDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleMainStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleMainEndDateChange = (date) => {
    setEndDate(date);
  };


  const handleSubmit = () => {
    setShowPreviewDSR(true);
  };

  const handleClose = () => {
    setOpenDSR(false);
    setShowPreviewDSR(false);
  };
  const findUserNameById = (userId) => {
    const user = users.find((user) => user._id === userId);
    return user ? user.name : "";
  };

  const filterByDateRange = (invoice) => {
    if (!startDate || !endDate) return true;
    const invoiceDate = moment(invoice.createdAt);
    return invoiceDate.isBetween(startDate, endDate, "day", "[]");
  };
  // For server-side pagination, we should avoid heavy client-side filtering
  // Only apply essential filters that don't interfere with pagination
  const filteredRows = rows.filter((row) => {
    // Only apply date range filter for now (other filters should be moved to server-side)
    return filterByDateRange(row);
  });
  const classes = useStyles2();

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    // Fetch new page data from server (Material-UI uses 0-based, server uses 1-based)
    const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
    const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
    dispatch(getMinimalInvoices(newPage + 1, rowsPerPage, formattedStartDate, formattedEndDate));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    // Fetch first page with new limit
    const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
    const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
    dispatch(getMinimalInvoices(1, newRowsPerPage, formattedStartDate, formattedEndDate));
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
  };
  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };
  // const handlesoftDelete = (id) => {
  //   const invoiceToDelete = rows.find((row) => row._id === id);

  //   if (invoiceToDelete?.paymentMode?.toLowerCase() === "credit") {
  //     alert("Warning: Credit invoices cannot be deleted!");
  //     return;
  //   }

  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to delete this invoice?"
  //   );
  //   if (confirmDelete) {
  //     dispatch(softdeleteInvoice(id, openSnackbar));
  //     openSnackbar("Invoice deleted successfully");
      
  //     // Refresh current page data after successful deletion
  //     const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
  //     const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
  //     dispatch(getMinimalInvoices(page + 1, rowsPerPage, formattedStartDate, formattedEndDate));
  //   }
  // };

  const canDeleteInvoice = () => {
    return permissions?.pages?.some(
      (p) => p.pageName === "Invoice" && p.canDelete
    );
  };

  console.log(permissions)

  // const canDeleteInvoice = () => {
  //   if (!permissions) return false;
  
  //   return permissions.pages?.some(
  //     (p) =>
  //       p.pageName?.toLowerCase() === "invoice" &&
  //       p.canDelete === true
  //   );
  // };
  
  
  const canDeletePermanently = () => {
    return permissions?.deleteRecordsPermanently === true;
  };
  
  // const handleDeleteInvoice = async (id) => {
  //   const invoice = rows.find((r) => r._id === id);
  
  //   if (invoice?.paymentMode?.toLowerCase() === "credit") {
  //     alert("Credit invoices cannot be deleted");
  //     return;
  //   }
  
  //   const confirmDelete = window.confirm(
  //     canDeletePermanently()
  //       ? "This will permanently delete the invoice. Continue?"
  //       : "Are you sure you want to delete this invoice?"
  //   );
  
  //   if (!confirmDelete) return;
  
  //   try {
  //     if (canDeletePermanently()) {
  //       // 🔥 HARD DELETE
  //       await api.permanentInvoiceDelete(id);
  //       openSnackbar("Invoice permanently deleted");
  //     } else {
  //       // 💤 SOFT DELETE
  //       dispatch(softdeleteInvoice(id));
  //       openSnackbar("Invoice deleted");
  //     }
  
  //     // Refresh list
  //     dispatch(getMinimalInvoices(page + 1, rowsPerPage));
  //   } catch (error) {
  //     openSnackbar("Failed to delete invoice");
  //   }
  // };
  
  const handleDeleteInvoice = async (id) => {
  const invoice = rows.find((r) => r._id === id);

  if (invoice?.paymentMode?.toLowerCase() === "credit") {
    alert("Credit invoices cannot be deleted");
    return;
  }

  const confirmDelete = window.confirm(
    canDeletePermanently()
      ? "This will permanently delete the invoice. Continue?"
      : "Are you sure you want to delete this invoice?"
  );

  if (!confirmDelete) return;

  try {
    if (canDeletePermanently()) {
      // 🔥 HARD DELETE
      await api.permanentInvoiceDelete(id);
      openSnackbar("Invoice permanently deleted");
    } else {
      // 💤 SOFT DELETE
      await dispatch(softdeleteInvoice(id));
      openSnackbar("Invoice deleted");
    }

    dispatch(getMinimalInvoices(page + 1, rowsPerPage));
  } catch (error) {
    console.error(error);
    openSnackbar("Failed to delete invoice");
  }
};


  const openInvoice = (id) => {
    history.push(`/invoice/${id}`);
  };
  const createAndDownloadPdf = () => {
    setLoading(true);
    
    // Check if we have any data to export
    const hasData = (startDate && endDate) ? pagination.totalCount > 0 : rows.length > 0;
    
    if (hasData) {
      setDownloadStatus("loading");
      
      // Format dates for server
      const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
      const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
      
      // Prepare request data
      const requestData = {
        profile: user.userProfile,
        logo: profiles.logo,
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
        users,
      };

      // Add current page data for backward compatibility (if no date range)
      if (!formattedStartDate || !formattedEndDate) {
        requestData.filteredRows = rows;
      }

      axios
        .post(`${process.env.REACT_APP_API}/create-report`, requestData)
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          const currentDate = new Date();
          
          // Generate filename based on date range
          let filename = `OrderReport${currentDate}`;
          if (formattedStartDate && formattedEndDate) {
            filename = `OrderReport_${formattedStartDate}_to_${formattedEndDate}_${moment(currentDate).format('YYYY-MM-DD')}`;
          }

          saveAs(pdfBlob, `${filename}.pdf`);
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoading(false);
          setDownloadStatus("success");
          
          // Show success message with date range info
          if (formattedStartDate && formattedEndDate) {
            openSnackbar(`PDF downloaded successfully for date range: ${formattedStartDate} to ${formattedEndDate}`);
          } else {
            openSnackbar("PDF downloaded successfully for all invoices");
          }
        })
        .catch((error) => {
          console.error("Error downloading PDF:", error);
          setLoading(false);
          setDownloadStatus("error");
          openSnackbar("Error downloading PDF. Please try again.");
        });
    } else {
      openSnackbar("No record to Export");
      setLoading(false);
    }
  };

  const createAndDownloadExcel = () => {
    setLoading(true);
    setDownloadStatus("loading");
    
    // Format dates properly for the server
    const formattedFromDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
    const formattedToDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
    
    // console.log('Sending dates to server:', { formattedFromDate, formattedToDate });
    
    // Show user what date range is being used
    const dateRangeText = formattedFromDate && formattedToDate 
      ? ` for ${formattedFromDate} to ${formattedToDate}`
      : ' (all invoices)';
    
    axios
      .post(`${process.env.REACT_APP_API}/invoices/comprehensive-excel-report`, {
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        users,
      }, {
        responseType: "blob",
      })
      .then((res) => {
        const excelBlob = new Blob([res.data], { 
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        });
        const currentDate = new Date();
        const fileName = `Comprehensive_Invoice_Report_${moment(currentDate).format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
        
        saveAs(excelBlob, fileName);
        setLoading(false);
        setDownloadStatus("success");
        openSnackbar(`Excel report downloaded successfully${dateRangeText}`);
      })
      .catch((error) => {
        console.error("Error downloading Excel report:", error);
        setLoading(false);
        setDownloadStatus("error");
        openSnackbar("Error downloading Excel report. Please try again.");
      });
  };
  
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const totalAmount = rows.reduce((total, row) => {
    if (typeof row.total === "number") {
      return total + row.total;
    } else {
      return total;
    }
  }, 0);
  const salespersonsProps = {
    options: users,
    getOptionLabel: (option) => option.name,
  };

  function checkStatus(status) {
    switch (status) {
      case "Partial":
        return {
          border: "solid 0px #1976d2",
          backgroundColor: "#baddff",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      case "Paid":
        return {
          border: "solid 0px green",
          backgroundColor: "#a5ffcd",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      case "Due":
        return {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      case "Cancelled":
        return {
          border: "solid 0px #ff6b6b",
          backgroundColor: "#ffd8d8",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      default:
        return {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        };
    }
  }

  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = filteredRows.map((n) => n._id);
      setSelectedInvoices(newSelected);
      return;
    }
    setSelectedInvoices([]);
  };

  const handleSelectInvoice = (id) => {
    const selectedIndex = selectedInvoices.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedInvoices, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedInvoices.slice(1));
    } else if (selectedIndex === selectedInvoices.length - 1) {
      newSelected = newSelected.concat(selectedInvoices.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedInvoices.slice(0, selectedIndex),
        selectedInvoices.slice(selectedIndex + 1)
      );
    }

    setSelectedInvoices(newSelected);
  };

  const handleBulkCancel = () => {
    if (selectedInvoices.length === 0) {
      openSnackbar("Please select invoices to cancel");
      return;
    }

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel ${selectedInvoices.length} selected invoice(s)?`
    );

    if (confirmCancel) {
      const invoicesToCancel = filteredRows.filter(
        (row) => 
          selectedInvoices.includes(row._id) && 
          row.paymentMode?.toLowerCase() !== "credit"
      );

      if (invoicesToCancel.length === 0) {
        openSnackbar("No valid invoices to cancel. Credit invoices cannot be canceled.");
        return;
      }

      // Cancel all selected invoices
      const cancelPromises = invoicesToCancel.map((invoice) => 
        dispatch(cancelInvoice(invoice._id, openSnackbar))
      );
      
      // Wait for all cancellations to complete, then refresh data
      Promise.all(cancelPromises).then(() => {
        setSelectedInvoices([]);
        openSnackbar(`Successfully canceled ${invoicesToCancel.length} invoice(s)`);
        
        // Refresh current page data after successful bulk cancellation
        const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        dispatch(getMinimalInvoices(page + 1, rowsPerPage, formattedStartDate, formattedEndDate));
      });
    }
  };

  const handleCancelInvoice = (id) => {
    const invoiceToCancel = rows.find((row) => row._id === id);

    if (invoiceToCancel?.paymentMode?.toLowerCase() === "credit") {
      alert("Warning: Credit invoices cannot be canceled!");
      return;
    }

    const confirmCancel = window.confirm(
      "Are you sure you want to cancel this invoice?"
    );

    if (confirmCancel) {
      dispatch(cancelInvoice(id, openSnackbar));
      openSnackbar("Invoice canceled successfully");
      
      // Refresh current page data after successful cancellation
      const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
      const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
      dispatch(getMinimalInvoices(page + 1, rowsPerPage, formattedStartDate, formattedEndDate));
    }
  };

  // Remove the early return for loading - we'll show the header always

  // Show empty state only when not loading and no data
  const showEmptyState = !isLoading && rows.length === 0;
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  return (
    <div
      style={{
        minHeight: isMobile ? "740px" : "470px",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          style={{
            width: isMobile ? "100%" : "85%",
            paddingTop: "2px",
            paddingBottom: "2px",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleMainStartDateChange}
                  required
                  format="yyyy/MM/dd"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleMainEndDateChange}
                  required
                  format="yyyy/MM/dd"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <FormControl style={{ width: "100px" }}>
                <InputLabel>Filter:</InputLabel>
                <Select
                  value={selectedFilter}
                  onChange={(event) => handleFilterChange(event)}
                >
                  <MenuItem value="salesperson">Filter by Store</MenuItem>
                  <MenuItem value="customer">Filter by Customer</MenuItem>
                  <MenuItem value="paymentMode">Filter by Payment Mode</MenuItem>
                  <MenuItem value="invoiceNumber">Filter by Invoice Number</MenuItem>
                </Select>
                {selectedFilter && (
                  <IconButton
                    size="small"
                    style={{
                      marginLeft: "8px",
                      backgroundColor: "transparent",

                      color: "#ef7f1a",
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      setSelectedFilter("");
                      setSearchQuery("");
                      setSalesperson("");
                      setParty("");
                      setPaymentMode("");
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                )}
              </FormControl>
              {selectedFilter && (
                <div>
                  {selectedFilter === "salesperson" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {salesperson && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "5px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {salesperson.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSalesperson(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            salesperson
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...salespersonsProps}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Sales Person"
                                margin="normal"
                                variant="outlined"
                              />
                            )}
                            value={users?.name}
                            onChange={(event, value) => {
                              setSalesperson(value);
                              setSearchQuery(value ? value.name : "");

                              console.log("value: ", value);
                            }}
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "customer" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {party && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "10px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {party.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setParty(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            party
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...clientsProps}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Customer"
                                margin="normal"
                                variant="outlined"
                              />
                            )}
                            value={clients?.name}
                            onChange={(event, value) => {
                              setParty(value);
                              setSearchQuery(value ? value.name : "");
                            }}
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "paymentMode" ? (
                    <div style={{ marginTop: "6.5px" }}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Payment Mode
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={paymentMode}
                          required={true}
                          onChange={(e, value) => {
                            setPaymentMode(e.target.value);
                            setSearchQuery(e.target.value);
                          }}
                          label="Payment Method"
                        >
                          <MenuItem value="Select">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value="Cash">Cash</MenuItem>
                          <MenuItem value="Online">Online</MenuItem>
                          <MenuItem value="Credit">Credit</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  ) : selectedFilter === "invoiceNumber" ? (
                    <div style={{ marginTop: "6.5px" }}>
                      <TextField
                        variant="outlined"
                        label="Enter Invoice Number"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className={classes.formControl}
                        style={{ width: "200px" }}
                      />
                    </div>
                  ) : null}
                </div>
              )}

              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                <>
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    disabled={loadingg || (!isAdminn && !canDownloadReports)}
                    style={{
                      margin: "16px 0 8px 0",
                      height: "50px",
                    }}
                  >
                    PDF
                  </Button>
                  
                  <Button
                    variant="outlined"
                    color="secondary"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadExcel}
                    disabled={loadingg || (!isAdminn && !canDownloadReports)}
                    style={{
                      // display: "none",
                      margin: "16px 0 8px 0",
                      height: "50px",
                      cursor:
                        loadingg || (!isAdminn && !canDownloadReports)
                          ? "not-allowed"
                          : "pointer",
                    }}
                    title="Download comprehensive Excel report with all invoice types, summary statistics"
                  >
                    Excel Report
                  </Button>
                </>
              )}

              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenDSR(true)}
                disabled={loadingg || (!isAdminn && !canDownloadReports)}
                style={{
                  margin: "16px 0 8px 0",
                  height: "50px",
                  cursor:
                    loadingg || (!isAdminn && !canDownloadReports)
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Sales Report
              </Button>

              <Button
                variant="outlined"
                color="primary"
                startIcon={<HistoryIcon />}
                onClick={() => history.push("/invoices/deleted")}
                style={{ margin: "16px 0 8px 0", height: "50px" }}
              >
                Delete History
              </Button>

              <Button
                variant="outlined"
                color="primary"
                startIcon={<HistoryIcon />}
                onClick={() => history.push("/invoices/canceled")}
                style={{ margin: "16px 0 8px 0", height: "50px" }}
              >
               Cancel History
              </Button>

                 <Button
                variant="outlined"
                color="primary"
                startIcon={<HistoryIcon />}
                onClick={() => history.push("/invoices/complimentary")}
                style={{ margin: "16px 0 8px 0", height: "50px" }}
              >
                Complimentary History
              </Button>

              <DSRDialog
                open={openDSR}
                onClose={handleClose}
                date={dateDSR}
                handleDateChange={handleDateChange}
                startDate={startDateDSR}
                handleStartDateChange={handleStartDateChange}
                endDate={endDateDSR}
                handleEndDateChange={handleEndDateChange}
                handleSubmit={handleSubmit}
                showPreview={showPreviewDSR}
                rows={rows}
                user={user}
                classes={classes}
              />

              {selectedInvoices.length > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<CancelIcon />}
                  onClick={handleBulkCancel}
                  style={{ margin: "16px 0 8px 0", height: "50px" }}
                >
                  Cancel Selected ({selectedInvoices.length})
                </Button>
              )}
            </div>
            {/* Date Range Summary - Show when dates are selected */}
            {startDate && endDate && (
              <div
                className={classes.textContainer}
              
              >
                
                <Typography variant="h6" className={classes.typography}>
                  Total Invoices: {pagination.totalCount || 0}
                </Typography>
                <Typography variant="h6" className={classes.typography} style={{ color: "#2e7d32", fontWeight: "bold" }}>
                  Total Amount: ₹{toCommas(dateRangeTotals.totalAmount.toFixed(2))}
                </Typography>
               
              </div>
            )}

            {/* Other Filters Summary */}
            {(salesperson || party || paymentMode) && (
              <div
                className={classes.textContainer}
                style={{ margin: isMobile ? "0" : "10px 0 0 2rem" }}
              >
                <Typography variant="h6" className={classes.typography}>
                  Orders Count: {pagination.totalCount || rows.length} 
                  {pagination.totalCount && ` (Page ${pagination.currentPage} of ${pagination.totalPages})`}
                </Typography>

                <Typography variant="h6" className={classes.typography}>
                  Current Page Total: ₹{toCommas(totalAmount.toFixed(2))}
                </Typography>
              </div>
            )}
          </div>

          {/* Show loader in table area when loading */}
          {isLoading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                paddingTop: "40px",
                paddingBottom: "40px",
                minHeight: "300px",
              }}
            >
              <Spinner />
              <Typography variant="body1" style={{ marginTop: "16px", color: "#666" }}>
                Loading invoices...
              </Typography>
            </div>
          ) : showEmptyState ? (
            /* Show empty state when not loading and no data */
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                paddingTop: "40px",
                paddingBottom: "40px",
                minHeight: "300px",
              }}
            >
              <NoData />
              <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
                No Order yet. Click the plus icon to create Order
              </p>
            </div>
          ) : (
            /* Show table when data is available */
            <TableContainer component={Paper} elevation={0}>
              <Table
                className={classes.table}
                aria-label="custom pagination table"
              >
                <TableHead>
                  <TableRow>
                  
                    <TableCell style={headerStyle}>Invoice Number</TableCell>
                    <TableCell style={headerStyle}>Date</TableCell>
                    <TableCell style={headerStyle}>Payment Mode</TableCell>
                    <TableCell style={headerStyle}>Customer</TableCell>
                    <TableCell style={headerStyle}>Invoice Amount</TableCell>
                    <TableCell style={headerStyle}>Status</TableCell>
                    <TableCell style={headerStyle}>Edit</TableCell>
                    <TableCell style={headerStyle}>Delete</TableCell>
                      <TableCell padding="checkbox" style={headerStyle}>
                      <Checkbox
                        indeterminate={selectedInvoices.length > 0 && selectedInvoices.length < filteredRows.length}
                        checked={filteredRows.length > 0 && selectedInvoices.length === filteredRows.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell style={headerStyle}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        Cancel Invoice
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row._id} style={{ cursor: "pointer" }}>
                      
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.invoiceNumber}
                      </TableCell>
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row._id)}
                      >
                        {moment(row.createdAt).format("MMM Do YYYY")}
                      </TableCell>
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.paymentMode}
                      </TableCell>
                      <TableCell style={tableStyle}>
                        {row?.client?.name ? row.client.name : "Cash"}
                      </TableCell>
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.currency}
                        {row.total ? toCommas(row.total.toFixed(2)) : row.total}
                      </TableCell>
                      <TableCell
                        style={{
                          ...tableStyle,
                          cursor: "pointer",
                        }}
                        onClick={() => openInvoice(row._id)}
                      >
                        <button
                          style={{
                            ...checkStatus(row.status),
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            openInvoice(row._id);
                          }}
                        >
                          {row.status}
                        </button>
                      </TableCell>
                  
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <Tooltip title="Edit Invoice" arrow placement="top">
                          <IconButton
                            onClick={() => editInvoice(row._id)}
                            disabled={
                              permissionsLoading ||
                              (!isAdmin() && !canUpdatePage("Invoice"))
                            }
                            style={{
                              cursor:
                                permissionsLoading ||
                                (!isAdmin() && !canUpdatePage("Invoice"))
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <BorderColorIcon
                              style={{ width: "20px", height: "20px" }}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <Tooltip title="Delete Invoice" arrow placement="top">
                          {/* <IconButton
                            disabled={
                              permissionsLoading ||
                              (!isAdmin() && !canDeletePage("Invoice"))
                            }
                            // onClick={() => handlesoftDelete(row._id)}
                            onClick={() => handleDeleteInvoice(row._id)}
                            style={{
                              cursor:
                                permissionsLoading ||
                                (!isAdmin() && !canDeletePage("Invoice"))
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <DeleteOutlineRoundedIcon
                              style={{ width: "20px", height: "20px" }}
                            />
                          </IconButton> */}
                          <IconButton
                            disabled={
                              permissionsLoading || !canDeleteInvoice()
                            }
                            onClick={() => handleDeleteInvoice(row._id)}
                            style={{
                              cursor:
                                permissionsLoading || !canDeleteInvoice()
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <DeleteOutlineRoundedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedInvoices.indexOf(row._id) !== -1}
                          onChange={() => handleSelectInvoice(row._id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </TableCell>
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Tooltip title="Cancel Invoice" arrow placement="top">
                            <IconButton
                              disabled={
                                permissionsLoading ||
                                (!isAdmin() && !canDeletePage("Invoice"))
                              }
                              onClick={() => handleCancelInvoice(row._id)}
                              style={{
                                cursor:
                                  permissionsLoading ||
                                  (!isAdmin() && !canDeletePage("Invoice"))
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            >
                              <CancelIcon style={{ width: "20px", height: "20px" }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        50,
                        100,
                        150,
                      ]}
                      colSpan={6}
                      count={pagination.totalCount || rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default Invoices;
